import {Box, Grid, List, MenuItem, Stack, Typography} from '@mui/material';
import React, {memo} from 'react';
import WidgetDivider from '../atomicComponents/WidgetDivider';
import {CenterOutDivider} from "../atomicComponents/CenterOutDivier";
import {useTheme} from "@mui/material/styles";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";


export const ToolsMenuItem = ({linkTo, label, disabled = false, sx = {}}) => {
  const theme = useTheme()
  return (
    <>
      <Button
        component={Link}
        to={linkTo}
        disabled={disabled}
        sx={{
          width: '100%',
          backgroundColor: 'white',
          borderRadius: 2,
          color: theme.palette.base.rothko2,
          border: `1px solid ${theme.palette.base.rothko6}`,
          whiteSpace: 'nowrap',
          transition: 'transform 0.2s, box-shadow 0.2s',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)',
          },
          ...sx
        }}
      >
        {label}
      </Button>
    </>
  );
}


const Tools = ({modalValue, modalSetter}) => {
  return (
    <>
      <Stack spacing={1}>
        <WidgetDivider
          label="SIMULATION DATABASE"
          value={modalValue}
          onChange={modalSetter}
        />
        <CenterOutDivider thickness={3} color="grey" animate delay={0} />
        {/*<ScrollableTools />*/}
      <Grid container>
        <Grid item xs={6} sm={6} md={12} lg={6} sx={{ px: 0 }}>
          {/* Make children align left / stretch */}
          <Stack alignItems="stretch" flex={1} spacing={1}>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/plot1d" label="Plot1d" /></Box>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/plot2d" label="Plot2d" /></Box>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/plot3d" disabled label="Plot3d" /></Box>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/data-products" label="Coronal Hole Maps" /></Box>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/time-series" label="Time Series" /></Box>
          </Stack>
        </Grid>

        <Grid item xs={6} sm={6} md={12} lg={6} sx={{ pl: { xs: 1, sm: 1, md: 0, lg: 1 }, pt: { xs: 0, sm: 0, md: 1, lg: 0 } }}>
          <Stack alignItems="stretch" flex={1} spacing={1}>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/spacecraft-mapping" label="Spacecraft Mapping" /></Box>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/white-light" label="White Light" /></Box>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/coronagraphs" label="Coronagraphs" /></Box>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/euv" label="EUV & X-Rays" /></Box>
            <Box sx={{ width: '100%' }}><ToolsMenuItem linkTo="/mhdweb2/tools/euv-comparison" label="EUV Imagers" /></Box>
          </Stack>
        </Grid>
      </Grid>

        <CenterOutDivider thickness={3} color="grey" animate delay={0} />
        <Box sx={{ width: '100%' }}>
          <ToolsMenuItem linkTo="/mhdweb2/tools/data-access" label="DATA ACCESS" />
        </Box>
      </Stack>

    </>
  );
}

export default memo(Tools);